import {
  PROPOSE_DETAIL, PROPOSE_DETAIL_FAILURE, PROPOSE_DETAIL_SUCCESS,
  PROPOSE_APPROVE, PROPOSE_APPROVE_FAILURE, PROPOSE_APPROVE_SUCCESS,
  PROPOSE_NOT_APPROVE, PROPOSE_NOT_APPROVE_FAILURE, PROPOSE_NOT_APPROVE_SUCCESS,
  PROPOSE_ADOPT, PROPOSE_ADOPT_FAILURE, PROPOSE_ADOPT_SUCCESS
} from './mutation-types'

export default {
  state: {
    propose: null,
    joint_1_user: null,
    joint_2_user: null
  },
  getters: {
    proposeDetail: state => {
      return state.propose
    },
    joint1User: state => {
      return state.joint_1_user
    },
    joint2User: state => {
      return state.joint_2_user
    }
  },
  actions: {
    [PROPOSE_DETAIL] ({dispatch, state, commit}, params) {
      var url = '/master/proposes/' + params.id
      var data = {}
      var callback = null
      data = params.data
      if (data) {
        callback = params.callback
      }
      dispatch('apiGet', {url: url, data: data, loadparams: true})
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(PROPOSE_DETAIL_FAILURE, res.data)
          } else {
            res.data.callback = callback
            commit(PROPOSE_DETAIL_SUCCESS, res.data)
          }
        }
      })
      .catch(error => {
        throw error
      })
    },
    [PROPOSE_APPROVE] ({dispatch, state, commit}, params) {
      var data = {}
      if (params) {
        data = params.data
      }
      dispatch('apiPatch', {url: '/master/proposes/' + params.id, data: data, loadparams: 'block'})
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(PROPOSE_APPROVE_FAILURE, res.data)
          } else {
            commit(PROPOSE_APPROVE_SUCCESS, { data: res.data, callback: params.callback })
          }
        }
      })
      .catch(error => {
        throw error
      })
    },
    [PROPOSE_NOT_APPROVE] ({dispatch, state, commit}, params) {
      var data = {}
      if (params) {
        data = params.data
      }
      dispatch('apiPatch', {url: '/master/proposes/not_approve/' + params.id, data: data, loadparams: 'block'})
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(PROPOSE_NOT_APPROVE_FAILURE, res.data)
          } else {
            commit(PROPOSE_NOT_APPROVE_SUCCESS, { data: res.data, callback: params.callback })
          }
        }
      })
      .catch(error => {
        throw error
      })
    },
    [PROPOSE_ADOPT] ({dispatch, state, commit}, params) {
      var data = {}
      if (params) {
        data = params.data
      }
      dispatch('apiPatch', {url: '/master/proposes/adopt/' + params.id, data: data, loadparams: 'block'})
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(PROPOSE_ADOPT_FAILURE, res.data)
          } else {
            commit(PROPOSE_ADOPT_SUCCESS, { data: res.data, callback: params.callback })
          }
        }
      })
      .catch(error => {
        throw error
      })
    }
  },
  mutations: {
    [PROPOSE_DETAIL_FAILURE] (state, data) {
      console.log('PROPOSE_DETAIL_FAILURE')
    },
    [PROPOSE_DETAIL_SUCCESS] (state, data) {
      console.log('PROPOSE_DETAIL_SUCCESS')
      state.propose = data.propose.data
      state.joint_1_user = data.joint_1_user
      state.joint_2_user = data.joint_2_user
      if (data.callback) {
        data.callback()
      }
    },
    [PROPOSE_APPROVE_FAILURE] (state, data) {
      console.log('PROPOSE_APPROVE_FAILURE')
    },
    [PROPOSE_APPROVE_SUCCESS] (state, data) {
      console.log('PROPOSE_APPROVE_SUCCESS')
      data.callback()
    },
    [PROPOSE_NOT_APPROVE_FAILURE] (state, data) {
      console.log('PROPOSE_NOT_APPROVE_FAILURE')
    },
    [PROPOSE_NOT_APPROVE_SUCCESS] (state, data) {
      console.log('PROPOSE_NOT_APPROVE_SUCCESS')
      data.callback()
    },
    [PROPOSE_ADOPT_FAILURE] (state, data) {
      console.log('PROPOSE_ADOPT_FAILURE')
    },
    [PROPOSE_ADOPT_SUCCESS] (state, data) {
      console.log('PROPOSE_ADOPT_SUCCESS')
      data.callback()
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/propose-detail.js